

import { UnitedOne as uo } from './Utils';


declare var jsData;

export namespace UnitedOne {

    import Event = uo.Event;
    import Notifier = uo.Notifier;

    export class Services {
        private static instance: Services;


        static getInstance() {
            if (!Services.instance) { Services.instance = new Services(); }
            return Services.instance;
        }

        public generals: ServicesGenerals;
        public monitoring: ServicesMonitoring;
        public userprofile: ServicesUserProfile;

        public dialogs: DialogServices;
        public notifications: NotificationServices;

        public eventBus: EventBusService;

        public area: string;
        public action: string;
        public controller: string;
        public isUserLoggedIn: boolean;

        public areaData: any;
        public actionData: any;
        public controllerData: any;
        public ci: any;

        public product: string = 'seosuite';

        private constructor() {

            this.dialogs = new DialogServices();
            this.notifications = new NotificationServices();
            this.eventBus = new EventBusService();

            this.area = jsData.generals.area;
            this.action = jsData.generals.action;
            this.controller = jsData.generals.controller;

            this.areaData = jsData.area;
            this.actionData = jsData.action;
            this.controllerData = jsData.controller;

            this.ci = jsData.generals.companyInformations;

            this.generals = new ServicesGenerals();

            this.isUserLoggedIn = jsData.generals.isUserLoggedIn;

            var area = this.generals.area.toLowerCase();
            var controller = this.generals.controller.toLowerCase();
            var action = this.generals.action.toLowerCase();

            if (area == 'userprofile') {
                this.product = 'common';
            }

            if (area == 'userprofile' && controller == 'content') {
                this.product = 'seosuite';
            }

            if (area == 'contentsuite') {
                this.product = 'contentsuite';
            }

            $('body').addClass(this.product);

            if (this.isUserLoggedIn && (this.generals.area == 'userprofile' || this.generals.area == 'contentsuite' || this.generals.area == 'seosuite') && (jsData.area != null)) {
                this.userprofile = new ServicesUserProfile(this);
            }


            if (controller == 'monitoring') {
                this.monitoring = new ServicesMonitoring();
            }

        }


    }

    export class ServicesGenerals {

        public baseUrl: string = jsData.generals.baseUrl;
        public apiBaseUrl: string = jsData.generals.apiBaseUrl;
        public frontendBaseUrl: string = jsData.generals.frontendBaseUrl;
        public cdnBaseUrl: string = jsData.generals.cdnBaseUrl;

        public area: string = jsData.generals.area.toLowerCase();
        public action: string = jsData.generals.action.toLowerCase();
        public controller: string = jsData.generals.controller.toLowerCase();
        public isUserLoggedIn: boolean = jsData.generals.isUserLoggedIn;
        public isDevelopmentUrl: boolean = jsData.generals.isDevelopmentUrl;

        public query: any = jsData.generals.query;

        public id: string = jsData.generals.id;



        get idAsInt(): number {
            return parseInt(this.id);
        }
    }



    export class ServicesUserProfile {



        public userId: number = jsData.area.currentUserId;

        public userRoles: Array<string> = jsData.area.userRoles;

        public isAdministrator: boolean = jsData.area.isUserAdministrator;
        public isSuperAdministrator: boolean = jsData.area.isCurrentUserSuperAdministrator;
        public isNewDesign: boolean = jsData.generals.isNewDesign;
        public isDeveloper: boolean = this.userRoles.contains('developer');
        public isBeta: boolean = this.userRoles.contains('beta');

        public searchEngines: Array<ServicesUserProfile_SearchEngineDefinition> = jsData.area.searchEngines;
        public devices: Array<ServicesUserProfile_DeviceDefinition> = jsData.area.devices;
        public locations: Array<ServicesUserProfile_LocationDefinition> = jsData.area.locations;

        public isApiEnabled: boolean = jsData.area.isApiEnabled;
        public apiKey: string = jsData.area.apiKey;
        public hasValidApiKey: string = jsData.area.hasValidApiKey;

        public currentProjectId: number = jsData.area.currentProjectId;

        public isInRole(role: string): boolean {
            return this.userRoles.any(x => x == role);
        }

        public projects: Array<ServicesUserProfile_Project>;

        public isUserManagedUser: boolean = jsData.area.isUserManagedUser;
        public directLoginGoBackPossibility: boolean = jsData.area.directLoginGoBackPossibility;

        constructor(public services: Services) {

            this.projects = new Array<ServicesUserProfile_Project>();
            for (var item of jsData.area.projectOfUser) {
                this.projects.push(new ServicesUserProfile_Project(item));
            }

            globalThis.developer = this.isDeveloper;
            globalThis.beta = this.isBeta;
            globalThis.newdesign = this.isNewDesign;

            if (this.isNewDesign) {
                $('body').addClass('newdesign');
            }

            if (this.isDeveloper) {
                $('body').addClass('developer');
            }

            if (this.isBeta) {
                $('body').addClass('beta');
            }
        }


        public getSetting(identifier: string, defaultValue: any, global: boolean = false) {

            var type = (typeof defaultValue).toString();

            if (type == 'object' && defaultValue instanceof Date) {
                type = 'date';
            }

            if (!global) {
                var generals = this.services.generals;
                identifier = generals.area + '.' + generals.controller + '.' + generals.action + '.' + identifier;
            }
            else {
                identifier = 'global.' + identifier;
            }

            identifier = identifier.toLowerCase();


            var item = jsData.area.loginSettings.first(x => x.identifier == identifier);

            if (item == null) {
                return defaultValue;
            }
            else {

                if (type == 'boolean') {
                    return item.value.toLowerCase() == 'true';
                }

                if (type == 'number') {
                    return Number(item.value);
                }

                if (type == 'date') {
                    return parseInt(item.value).toDate();
                }

                return item.value;
            }
        }

        public setSetting(identifier: string, value: any, global: boolean = false) {

            if (!global) {
                var generals = this.services.generals;
                identifier = generals.area + '.' + generals.controller + '.' + generals.action + '.' + identifier;
            }
            else {
                identifier = 'global.' + identifier;
            }
            identifier = identifier.toLowerCase();

            var type = (typeof value).toString();

            if (type == 'object' && value instanceof Date) {
                type = 'date';
            }

            if (type == 'date') {
                value = (value as Date).getTime();
            }


            if (type == 'boolean') {
                value = value.toString();
            }

            var item = jsData.area.loginSettings.first(x => x.identifier == identifier);


            if (item == null || item.value != value) {

                var data = { identifier: identifier, value: value == null ? '' : value.toString() };
                uo.Utils.AjaxRequest('/UserProfile/Layout/LoginSettingSaveChanges/', data, data => { });

                if (item == null) {
                    jsData.area.loginSettings.push({ identifier: identifier, value: value });
                }
                else {
                    item.value = value;
                }
            }
        }


        public hasRight(right: LoginRights): boolean {
            if (!jsData.area) {
                return false;
            }

            return jsData.area.loginRights.any(x => x == right.toString());
        }

    }

    export class ServicesUserProfile_Project {
        public id: number;
        public title: string;
        public projectUrl: string;
        public faviconData: string;

        constructor(item: any) {
            this.id = item.id;
            this.title = item.title;
            this.projectUrl = item.projectUrl;
            this.faviconData = item.faviconData;
        }
    }

    export class ServicesUserProfile_SearchEngineDefinition {
        public id: number;
        public title: string;
        public engineIcon: string;
        public languageIcon: string;
    }

    export class ServicesUserProfile_DeviceDefinition {
        public id: number;
        public title: string;
        public icon: string;
    }

    export class ServicesUserProfile_LocationDefinition {
        public id: number;
        public googleLocationId: number;
        public title: string;
        public icon: string;
    }


    export class ServicesMonitoring {

        public keywordFilterSelectionChanged: Event;
        public domainSelectionChanged: Event;



        public domainOrKeywordFilterSelectionChanged: Event;

        public monitoringInitialized: Event;

        public selectedDomain: string;

        constructor() {
            this.keywordFilterSelectionChanged = new Event();
            this.domainSelectionChanged = new Event();
            this.domainOrKeywordFilterSelectionChanged = new Event();

            this.keywordFilterSelectionChanged.subscribe(() => this.onDomainOrKeywordFilterSelectionChanged());
            this.domainSelectionChanged.subscribe(() => this.onDomainOrKeywordFilterSelectionChanged());

            this.monitoringInitialized = new Event();

            this.selectedDomain = jsData.controller.selectedDomain;
        }

        private onDomainOrKeywordFilterSelectionChanged(): void {
            this.domainOrKeywordFilterSelectionChanged.emit();
        }
    }



    export class DialogServices {

        public alertHandler: (message: string, title?: string) => void;
        public alert(message: string, title?: string) {
            if (this.alertHandler != null) this.alertHandler(message, title);
        }

        public confirmHandler: (message: string, callback: (result: boolean) => void, title: string) => void;
        public confirm(message: string, callback: (result: boolean) => void, title?: string) {
            if (this.confirmHandler != null) this.confirmHandler(message, callback, title);
        }
        public confirmTrue(message: string, callback: () => void, title?: string) {
            if (this.confirmHandler != null) {
                this.confirmHandler(message, (result) => {
                    if (result) {
                        callback();
                    }
                }, title);
            }
        }

        public confirmWithBusyHandler: (message: string, callback: (result: boolean, dialog: uo.DialogViewModelBase) => void, title: string) => void;
        public confirmTrueWithBusy(message: string, callback: (dialog: uo.DialogViewModelBase) => void, title?: string) {
            if (this.confirmWithBusyHandler != null) {
                this.confirmWithBusyHandler(message, (result, dialog) => {
                    if (result) {
                        callback(dialog);
                    }
                    else {
                        dialog.close();
                    }
                }, title);
            }
        }

        public promptHandler: (message: string, callback: (result: string) => void, title: string, defaultValue?: string) => void;
        public prompt(message: string, callback: (result: string) => void, title?: string, defaultValue?: string) {
            if (this.promptHandler != null) this.promptHandler(message, callback, title, defaultValue);
        }

        public editViewConfigHandler: (viewConfig: any, callback: (viewConfig: any) => void) => void;
        public editViewConfig(viewConfig: any, callback: (viewConfig: any) => void) {
            if (this.editViewConfigHandler != null) this.editViewConfigHandler(viewConfig, callback);
        }

        public progressViewConfigHandler: (viewConfig: any, coordinates: any, element: HTMLElement) => void;
        public progressViewConfig(viewConfig: any, coordinates: any, element: HTMLElement) {
            if (this.progressViewConfigHandler != null) this.progressViewConfigHandler(viewConfig, coordinates, element);
        }


        constructor() {

        }
    }

    export class EventBusService {
        public leftPanelVisibilityChanged: Event = new Event();
        public rightPanelVisibilityChanged: Event = new Event();
        public panelVisibilityChanged: Event = new Event();

        public onLeftPanelVisibilityChanged(): void {
            this.leftPanelVisibilityChanged.emit();
            this.panelVisibilityChanged.emit();
        }

        public onRightPanelVisibilityChanged(): void {
            this.rightPanelVisibilityChanged.emit();
            this.panelVisibilityChanged.emit();
        }
    }

    export class NotificationServices {

        public notify(message: string, type: string, stayDuration?: number) {
            Notifier.showNotification(message, type, stayDuration);
        }

        public success(message: string, stayDuration?: number) {
            this.notify(message, 'success', stayDuration);
        }

        public danger(message: string, stayDuration?: number) {
            this.notify(message, 'danger', stayDuration);
        }

        public warning(message: string, stayDuration?: number) {
            this.notify(message, 'warning', stayDuration);
        }

        public info(message: string, stayDuration?: number) {
            this.notify(message, 'info', stayDuration);
        }

        public changesSaved() {
            this.notify('Änderungen wurden gespeichert.', 'success');
        }




        constructor() { }
    }





    export enum LoginRights {
    
        Common_ManageGoogleApiConnections = 'Common_ManageGoogleApiConnections',
        SeoSuite = 'SeoSuite',
        SeoSuite_Explorer = 'SeoSuite_Explorer',
        SeoSuite_Monitoring = 'SeoSuite_Monitoring',
        SeoSuite_Monitoring_ManageKeywords = 'SeoSuite_Monitoring_ManageKeywords',
        SeoSuite_SearchConsole = 'SeoSuite_SearchConsole',
        SeoSuite_Optimization = 'SeoSuite_Optimization',
        SeoSuite_Lighthouse = 'SeoSuite_Lighthouse',
        SeoSuite_Links = 'SeoSuite_Links',
        SeoSuite_Landingpages = 'SeoSuite_Landingpages',
        SeoSuite_Tools = 'SeoSuite_Tools',
        SeoSuite_Reporting = 'SeoSuite_Reporting',
        SeoSuite_Reporting_EditReports = 'SeoSuite_Reporting_EditReports',
        SeoSuite_Reporting_ManageSettings = 'SeoSuite_Reporting_ManageSettings',
        ContentSuite = 'ContentSuite',
        Shared_KeywordList = 'Shared_KeywordList',
        Shared_KeywordList_Edit = 'Shared_KeywordList_Edit',
        Shared_KeywordResearch = 'Shared_KeywordResearch',
        Shared_KeywordResearch_Edit = 'Shared_KeywordResearch_Edit'
      }
      
      
      
}

var services = UnitedOne.Services.getInstance();
